import { render } from "./SaySubform.vue?vue&type=template&id=b59ea65e"
import script from "./SaySubform.vue?vue&type=script&lang=js"
export * from "./SaySubform.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__